var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    {
      attrs: { title: _vm.title, button_add: true },
      on: { click_add: _vm.row_create },
    },
    [
      _c("v-data-table", {
        staticStyle: { "white-space": "nowrap" },
        attrs: {
          headers: _vm.customHeaders,
          items: _vm.items,
          "hide-default-header": _vm.empty,
          height: _vm.items.length > 7 ? 32 * 7 + 32 + 16 : undefined,
          "disable-pagination": "",
          "hide-default-footer": "",
          dense: "",
          "show-select": _vm.bulkMode,
          "item-key": "_rowKey",
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function () {
              return [
                _vm.showBulk && _vm.items.length >= 2
                  ? _c(
                      "div",
                      { staticClass: "d-flex pl-4 pb-1 align-center" },
                      [
                        _c("v-checkbox", {
                          staticClass: "mt-0 pt-0",
                          attrs: {
                            "hide-details": "",
                            disabled: !_vm.items.length,
                          },
                          model: {
                            value: _vm.bulkMode,
                            callback: function ($$v) {
                              _vm.bulkMode = $$v
                            },
                            expression: "bulkMode",
                          },
                        }),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-2 white--text",
                            attrs: {
                              "x-small": "",
                              color: "red",
                              disabled:
                                !_vm.bulkMode || !_vm.deletableCountLocal,
                            },
                            on: { click: _vm.bulkRemove },
                          },
                          [
                            _vm._v(" Bulk Delete "),
                            _vm.deletableCountLocal
                              ? _c("span", [
                                  _vm._v(
                                    " (" + _vm._s(_vm.deletableCountLocal) + ")"
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "item.label",
            fn: function ({ item }) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.label + " " + _vm.getItemIndex(item)) + " "
                ),
              ]
            },
          },
          {
            key: "item.day",
            fn: function ({ item }) {
              return [_vm._v(" " + _vm._s(item.points) + " ")]
            },
          },
          {
            key: "item.percent",
            fn: function ({ item }) {
              return [_vm._v(" " + _vm._s(item.percent + "%") + " ")]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_update(item)
                      },
                    },
                  },
                  [_vm._v("mdi-pencil")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_copy(item)
                      },
                    },
                  },
                  [_vm._v("mdi-content-copy")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_remove(item)
                      },
                    },
                  },
                  [_vm._v("mdi-delete")]
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c("r-stash-bonus-bunch-dialog", { ref: "dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }